export default ({ palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > input': {
      height: 30,
      paddingLeft: 8,
      marginBottom: 4,
      width: '100%',
    },
  },
  field: {
    marginBottom: '8px !important',
  },
  forgotPassword: {
    cursor: 'pointer',
    color: palette.primary.main,
    fontSize: '.9rem',
    margin: '2rem 0 0',
    alignSelf: 'flex-end',
  },
  loginButton: {
    marginTop: '1rem',
    width: '100%',
    '&:hover': {
      backgroundColor: palette.primary.light,
    },
  },
});
